import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteHonorarVereinbarungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteHonorarVereinbarungCommandService],
  exports: []
})
export class DeleteHonorarVereinbarungCommandServiceModule { }
